import { Layout } from '@/components/Layout/Layout'
import { ProtectedRoute } from '@/components/routes/ProtectedRoute'
import { lazy } from 'react'
import { Route } from 'react-router-dom'

// Lazy load main app pages to prevent mounting on registration pages
const Campaigns = lazy(() => import('@/pages/campaigns/Campaigns').then((m) => ({ default: m.Campaigns })))
const CampaignDetailsPage = lazy(() => import('@/pages/campaigns/CampaignDetails'))
const InfluencerDetailsPage = lazy(() => import('@/pages/dashboard/InfluencerDetails').then((m) => ({ default: m.InfluencerDetailsPage })))
const Influencers = lazy(() => import('@/pages/influencers/Influencers').then((m) => ({ default: m.Influencers })))
const InfluencerDetails = lazy(() => import('@/pages/influencerDetails'))
const Profile = lazy(() => import('@/pages/profile/Profile').then((m) => ({ default: m.Profile })))

export const MainRoutes = () => {
  return (
    <Route
      element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }
    >
      <Route path="dashboard" element={<Campaigns />} />
      <Route path="dashboard/influencer/:id" element={<InfluencerDetailsPage />} />
      <Route path="influencers" element={<Influencers />} />
      <Route path="influencers/:id" element={<InfluencerDetails />} />
      <Route path="profile" element={<Profile />} />
      <Route path="campaigns">
        <Route index element={<Campaigns />} />
        <Route path=":id" element={<CampaignDetailsPage />} />
      </Route>
    </Route>
  )
}
